<template>
  <customModal :containersm="true" @closeModal="$emit('close')">
    <template #title>
      {{ fieldName }} Audit Trail
    </template>

    <template #body>
      <div class="modal-scroll-body">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="table-light">
              <tr>
                <th> {{ fieldName }} </th>
                <th> Date </th>
              </tr>
            </thead>

            <tbody>
              <!-- Loading -->
              <tr v-if="loading">
                <td colspan="5" class="text-center">
                  Loading...
                </td>
              </tr>

              <tr v-for="(item, i) in auditData" :key="i">
                <td>{{ item.newValue }}</td>
                <td>{{ formatDate(item.changedAt) }}</td>
              </tr>

              <!-- Empty -->
              <tr v-if="!loading && !auditData.length">
                <td colspan="5" class="text-center text-muted">
                  No audit data available
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./FieldAuditPopup.js"></script>